export const FETCH_OPEN_API_KEY_STATUS_REQUEST = 'FETCH_OPEN_API_KEY_STATUS_REQUEST'
export const FETCH_OPEN_API_KEY_STATUS_SUCCESS = 'FETCH_OPEN_API_KEY_STATUS_SUCCESS'
export const FETCH_OPEN_API_KEY_STATUS_FAILED = 'FETCH_OPEN_API_KEY_STATUS_FAILED'
export const CREATE_OPEN_API_KEY_REQUEST = 'CREATE_OPEN_API_KEY_REQUEST'
export const CREATE_OPEN_API_KEY_SUCCESS = 'CREATE_OPEN_API_KEY_SUCCESS'
export const CREATE_OPEN_API_KEY_FAILED = 'CREATE_OPEN_API_KEY_FAILED'
export const DELETE_OPEN_API_KEY_REQUEST = 'DELETE_OPEN_API_KEY_REQUEST'
export const DELETE_OPEN_API_KEY_SUCCESS = 'DELETE_OPEN_API_KEY_SUCCESS'
export const DELETE_OPEN_API_KEY_FAILED = 'DELETE_OPEN_API_KEY_FAILED'
export const UPDATE_SYNC_ACCOUNT_REQUEST = 'UPDATE_SYNC_ACCOUNT_REQUEST'
export const UPDATE_SYNC_ACCOUNT_SUCCESS = 'UPDATE_SYNC_ACCOUNT_SUCCESS'
export const UPDATE_SYNC_ACCOUNT_FAILED = 'UPDATE_SYNC_ACCOUNT_FAILED'
export const UPDATE_PERIOD_EXTENSION_REQUEST = 'UPDATE_PERIOD_EXTENSION_REQUEST'
export const UPDATE_PERIOD_EXTENSION_SUCCESS = 'UPDATE_PERIOD_EXTENSION_SUCCESS'
export const UPDATE_PERIOD_EXTENSION_FAILED = 'UPDATE_PERIOD_EXTENSION_FAILED'
export const FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST = 'FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST'
export const FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS = 'FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS'
export const FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED = 'FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED'
export const FETCH_OPEN_API_DAILY_USAGE_REQUEST = 'FETCH_OPEN_API_DAILY_USAGE_REQUEST'
export const FETCH_OPEN_API_DAILY_USAGE_SUCCESS = 'FETCH_OPEN_API_DAILY_USAGE_SUCCESS'
export const FETCH_OPEN_API_DAILY_USAGE_FAILED = 'FETCH_OPEN_API_DAILY_USAGE_FAILED'
